import React, { Component } from 'react';
import { DatePicker } from 'antd';

import withFormItem from 'components/hocs/withFormItem';

@withFormItem
export default class DatePickerComponent extends Component {
    onChange = (e) => {
        const { field: { name }, form: { setFieldValue } } = this.props;

        setFieldValue(
            name,
            e
        );
    }

    render() {
        const { field: { name, value }, type, placeholder, disabled } = this.props;

        return (
            <DatePicker
                name={name}
                type={type}
                value={value}
                onChange={this.onChange}
                placeholder={placeholder}
                disabled={disabled}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/common/form/DatePicker.js